import { getData, postData } from '@/utils/http'
import config from '@/config'
import moment from 'moment'
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],

        //查询条件
        pageIndex: 1,
        total: 0,
        projectId: '',
        year:moment().format('yyyy'),
        month:moment().format('MM'),
        name: '',
        code: ''
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取列表
        getList({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/finance/route/data`, {
                    page: state.pageIndex,
                    size: config.pageSize,
                    projectId: state.projectId,
                    year: state.year,
                    month: state.month,
                    name:state.name,
                    code: state.code
                }).then(res => {
                    if (res.state == 1) {
                        commit('CHANGE_TABLE_DATA', res)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        getIinfoById({ commit, state },data) {
            return new Promise(resolve => {
                getData(`logistics/finance/route/details?routeId=${data.id}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取指定调度列表里的运输线路信息
        logisticsRouteGet({ commit, state }, id) {
            return new Promise(resolve => {
                getData(`logistics/route/get/${id}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '获取成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取指定调度列表的调度方案
        logisticsOrderGetDispatch({ commit, state }, id) {
            return new Promise(resolve => {
                getData(`logistics/order/get/dispatch/${id}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '获取成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //添加
        add({ commit }, addData) {
            return new Promise(resolve => {
                postData(`logistics/order/save`, addData).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //下单
        sureOrder({ commit }, addData) {
            return new Promise(resolve => {
                postData(`logistics/order/submit`, addData).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //撤回
        cencleOrder({ commit }, addData) {
            return new Promise(resolve => {
                postData(`logistics/order/withdraw`, addData).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        remove({ commit }, addData) {
            return new Promise(resolve => {
                postData(`logistics/order/remove`, addData).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //获取我的项目列表
        getMyProjectList({ commit, state },deptId) {
            return new Promise(resolve => {
                getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功',
                            data: res.data
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        })
                    }
                })
            })
        },

        //获取我的路线列表
        getRouteList({ commit, state }, projectId) {
            return new Promise(resolve => {
                getData(`logistics/route/list?projectId=${projectId}&status=4&name=&code=&page=1&size=99999`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功',
                            data: res.data.rows
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        })
                    }
                })
            })
        },

        getAllowOrg({ commit, state }, year) {
            return new Promise((resolve) => {
                getData(`logistics/sys/dept/get/list`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: "操作成功",
                            data: res.data
                        });
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        });
                    }
                })
            })
        },

        //获取运单详情
        getWaybillDetails({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/waybill/details/${state.activeItem.id}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //写入当前操作条目
        setActiveItem({ commit }, item) {
            commit('CHANGE_ACTIVE_ITEM', item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
